<template>
  <div id="app" class="home-page">
    <HeaderPage v-if="$route.meta.showHeader" />
    <router-view />
    <FooterPage v-if="$route.meta.showFooter" />
  </div>
</template>

<script>
import HeaderPage from './components/Header.vue'
import FooterPage from './components/Footer.vue'
import '@/assets/js/iconfont.js'

export default {
  name: 'App',
  components: {
    HeaderPage,
    FooterPage
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

:root {
  --primary-color: #e53935;
  --primary-dark: #c62828;
  --primary-light: #ffcdd2;
  --secondary-color: #1976d2;
  --bg-color: #f8f9fa;
  --card-bg: #ffffff;
  --text-primary: #212529;
  --text-secondary: #6c757d;
  --border-color: #e9ecef;
  --success-color: #4caf50;
  --warning-color: #ef6c00;
  --error-color: #f44336;
  --gold-color: #d4af37;
  --gold-light: #f4e4bc;
  --gradient-primary: linear-gradient(135deg, #e53935 0%, #c62828 100%);
  --gradient-secondary: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);
  --gradient-gold: linear-gradient(135deg, #d4af37 0%, #b8941f 100%);
  --shadow-sm: 0 2px 4px rgba(0,0,0,0.05);
  --shadow-md: 0 4px 12px rgba(0,0,0,0.1);
  --shadow-lg: 0 8px 24px rgba(0,0,0,0.12);
  --radius-sm: 8px;
  --radius-md: 12px;
  --radius-lg: 16px;
  --max-width: 1400px;
}

a {
  color: #1976d2;
  text-decoration: none;
}

.body-content {
  --bg-color: #f5f5f5;
  --shadow-sm: 0 2px 8px rgba(0,0,0,0.08);
  --shadow-md: 0 4px 16px rgba(0,0,0,0.12);
  --shadow-lg: 0 8px 32px rgba(0,0,0,0.16);
}

.home-page {
  font-family: 'Noto Sans SC', 'Microsoft YaHei', sans-serif;
  background-color: var(--bg-color);
  color: var(--text-primary);
  line-height: 1.6;
  font-size: 16px;
  min-height: 100vh;
}

@media (min-width: 1920px) {
  :root {
    --max-width: 1600px;
  }
}

.icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
</style>
